import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataProductSolutionsState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataProductSolutionsReducer.staticDataProductSolutionsFeatureKey]
);


export const getStaticDataCountriesResponse = createSelector(
  getStaticDataProductSolutionsState,
  staticDataCountriesReducer.fromStaticDataProductSolutionsReducer.getStaticDataProductSolutions
);
